import { ROUTE_CLUB_ROOT, ROUTE_CLUB_NEW, ROUTE_CLUB_EDIT } from './constants';
import ClubList from './ClubList';
import ClubEdit from './ClubEdit';
import ClubNew from './ClubNew';
export default {
  path: ROUTE_CLUB_ROOT,
  indexRoute: {
    name: 'clubList',
    component: ClubList
  },
  childRoutes: [
    // new item
    { path: ROUTE_CLUB_NEW, component: ClubNew },
    // edit item,
    { path: ROUTE_CLUB_EDIT, component: ClubEdit }
  ]
}



// WEBPACK FOOTER //
// ./src/components/Clubs/router.js